import { Injectable, Injector } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ShellService } from './shell.service';

@Injectable({
  providedIn: 'root'
})
export class UiService {
  constructor(
    private alertCtrl: AlertController,
    private injector: Injector
  ) {}

  // ShellService depends on UiService, so the shell is looked up on first use.
  private get shell(): ShellService {
    return this.injector.get(ShellService)
  }

  async showAlert(title: string, msg: string) {
    const alert = await this.alertCtrl.create({
      header: title,
      subHeader: msg,
      buttons: ['OK'],
      cssClass: 'rt-alert'
    })
    return alert.present()
  }

  /** Kept for callers that predate ShellService; nearly all of them report errors. New code calls shell.toast. */
  async showToast(msg: string, tone: 'ok' | 'error' = 'error') {
    this.shell.toast({ title: msg, tone })
  }

  async confirmPrompt(header: string, message: string, ok_text: string, cancel_text: string): Promise<boolean> {
    return new Promise(async (resolve) => {
      const buttons = [];
      if (ok_text  && ok_text.length) {
        buttons.push({text: ok_text, handler: () => {return resolve(true) }});
      }
      if (cancel_text  && cancel_text.length) {
        buttons.push({text: cancel_text, role: 'cancel', handler: () => {return resolve(false) }});
      }
      const alert = await this.alertCtrl.create({
        header: header,
        message: message,
        backdropDismiss: false,
        buttons,
        cssClass: 'rt-alert'
      })
      await alert.present()
    })
  }
}
